<template>
  <section class="section">
    <div class="container">
      <img class="coming-soon" :src="$t('blog.coming_soon')" />
    </div>
  </section>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: this.$t('blog.title')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Blog.vue?fb73ab7a